// Organization Packages
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const PROCESS_ENDED_PROPS = {
  dataTestId: 'process-ended-container',
  image: 'illustration_feedback_great',
  variant: VARIANTS.EmptyStatusVariantType.DEFAULT,
};

export { PROCESS_ENDED_PROPS };
